<script setup>
useHead({
    bodyAttrs: {
        class: "relative w-screen h-screen bg-hd-base-original",
    },
});
</script>
<template>
    <slot />
</template>
